import { useState, useCallback, useEffect } from 'react'

type MenuVariant = 'current' | 'v1'

const STORAGE_KEY = 'menuVariant'
export const BANNER_DISMISSED_KEY = 'menuBannerDismissed'

function getStoredVariant(): MenuVariant {
  const stored = localStorage.getItem(STORAGE_KEY)
  return stored === 'v1' ? 'v1' : 'current'
}

export function useMenuVariant() {
  const [variant, setVariant] = useState<MenuVariant>(getStoredVariant)

  // Sync across instances when localStorage changes (e.g. toggle called in another component)
  useEffect(() => {
    const handleStorage = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY) {
        setVariant(e.newValue === 'v1' ? 'v1' : 'current')
      }
    }
    window.addEventListener('storage', handleStorage)
    return () => window.removeEventListener('storage', handleStorage)
  }, [])

  const toggle = useCallback(() => {
    const current = localStorage.getItem(STORAGE_KEY) === 'v1' ? 'v1' : 'current'
    const next: MenuVariant = current === 'current' ? 'v1' : 'current'
    localStorage.setItem(STORAGE_KEY, next)
    localStorage.removeItem(BANNER_DISMISSED_KEY)
    setVariant(next)
    // Dispatch so other hook instances on the same page (e.g. Navbar) sync
    window.dispatchEvent(new StorageEvent('storage', { key: STORAGE_KEY, newValue: next }))
  }, [])

  return { variant, toggle }
}
